import React, { Fragment, useEffect, useState } from 'react';
import { Col, Container, Row, TabContent, TabPane } from 'reactstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import NavAuth from '../Auth/Nav';
import LoginTab from '../Auth/Tabs/LoginTab';
import RegisterTab from '../Auth/Tabs/RegisterTab';
import ForgotTab from '../Auth/Tabs/ForgotTab';
/* logo-login.png и logo2.png — логотипы купленной темы: фиолетовый кружок
   и надпись «Tivo». Ставим тот же векторный знак «Волшебного мира», что и
   в кабинете: человек должен видеть один логотип до входа и после. */
import FwLogo from '../Layout/Sidebar/FwLogo';

const getTabFromPath = (pathname) => {
    if (pathname.endsWith('/register')) return 'register';
    if (pathname.endsWith('/password-recovery')) return 'forgot';
    return 'login';
};


const LoginSample = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [selected, setSelected] = useState(getTabFromPath(location.pathname));

    useEffect(() => {
        setSelected(getTabFromPath(location.pathname));
    }, [location.pathname]);

    const callbackNav = (select) => {
        setSelected(select);
        const base = process.env.PUBLIC_URL || '';
        const q = location.search || '';
        if (select === 'login') {
            navigate(`${base}/login${q}`);
        } else if (select === 'register') {
            navigate(`${base}/register${q}`);
        } else if (select === 'forgot') {
            navigate(`${base}/password-recovery${q}`);
        }
    };

    return (
        <Fragment>
            <Container fluid={true} className="p-0">
                <Row className='mx-0'>
                    <Col xs="12" className='px-0'>
                        <div className="login-card auth-login fw-auth">
                            <div>
                                <div className="logo logo-login fw-auth-logo">
                                    <FwLogo />
                                    <span>Волшебный Мир</span>
                                </div>
                            </div>
                            <div className="login-main1 login-tab1 login-main">
                                <NavAuth callbackNav={callbackNav} selected={selected} />
                                <TabContent activeTab={selected} className="content-login">
                                    <TabPane className="fade show" tabId="login">
                                        <LoginTab />
                                    </TabPane>
                                    <TabPane className="fade show" tabId="register">
                                        <RegisterTab />
                                    </TabPane>
                                    <TabPane className="fade show" tabId="forgot">
                                        <ForgotTab />
                                    </TabPane>
                                </TabContent>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default LoginSample;